import { AppProps } from 'next/app';
import Router from 'next/router';
import NProgress from 'nprogress';
import { FunctionComponent } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider } from 'styled-components';

import { getTheme } from '../theme/getTheme';

import { Global } from '@emotion/react';
import '../css/main.css';

const queryClient = new QueryClient();

NProgress.configure({ showSpinner: false });
Router.events.on('routeChangeStart', () => NProgress.start());
Router.events.on('routeChangeError', () => NProgress.done());
Router.events.on('routeChangeComplete', () => {
  document.body.scrollTo({ top: 0 });
  NProgress.done();
});

const App: FunctionComponent<AppProps> = ({ Component, pageProps }) => {
  return (
    <ThemeProvider theme={getTheme()}>
      <QueryClientProvider client={queryClient}>
        <Component {...pageProps} />

        <Global
          styles={() => {
            const isUnifiDisplay =
              typeof navigator !== 'undefined' &&
              navigator?.userAgent?.includes('unifi_display');

            if (isUnifiDisplay) {
              return `
                #info-strip, #hs-eu-cookie-confirmation {
                  display: none !important;
                }
            `;
            }

            return ``;
          }}
        />
      </QueryClientProvider>
    </ThemeProvider>
  );
};

export default App;
